{
  "AGENT_BOTS": {
    "HEADER": "Botok",
    "LOADING_EDITOR": "Szerkesztő betöltése...",
    "DESCRIPTION": "Agent Bots are like the most fabulous members of your team. They can handle the small stuff, so you can focus on the stuff that matters. Give them a try. You can manage your bots from this page or create new ones using the 'Add Bot' button.",
    "LEARN_MORE": "Learn about agent bots",
    "COUNT": "{n} bot | {n} bots",
    "SEARCH_PLACEHOLDER": "Search bots...",
    "NO_RESULTS": "No bots found matching your search",
    "GLOBAL_BOT": "System bot",
    "GLOBAL_BOT_BADGE": "Rendszer",
    "AVATAR": {
      "SUCCESS_DELETE": "Bot avatar deleted successfully",
      "ERROR_DELETE": "Error deleting bot avatar, please try again"
    },
    "BOT_CONFIGURATION": {
      "TITLE": "Válassz ügynököt",
      "DESC": "Rendeljen egy Agent Botot a postaládájához. Ők képesek kezelni a kezdeti beszélgetéseket, és szükség esetén átirányítani őket egy emberhez.",
      "SUBMIT": "Frissítés",
      "DISCONNECT": "Bot lekapcsolása",
      "SUCCESS_MESSAGE": "Ügynök frissítve.",
      "DISCONNECTED_SUCCESS_MESSAGE": "Ügynök leválasztva.",
      "ERROR_MESSAGE": "Nem sikerült frissíteni a botot. Kérjük, próbálja meg újra.",
      "DISCONNECTED_ERROR_MESSAGE": "Nem sikerült leválasztani az botot. Kérjük, próbálja meg újra.",
      "SELECT_PLACEHOLDER": "Válassza ki a botot"
    },
    "ADD": {
      "TITLE": "Add Bot",
      "CANCEL_BUTTON_TEXT": "Mégse",
      "API": {
        "SUCCESS_MESSAGE": "Bot hozzáadva.",
        "ERROR_MESSAGE": "Nem tudott botot hozzáadni. Kérjük, próbálja meg később újra."
      }
    },
    "LIST": {
      "404": "No bots found. You can create a bot by clicking the 'Add Bot' button.",
      "LOADING": "Botok hívása...",
      "TABLE_HEADER": {
        "DETAILS": "Bot Details",
        "URL": "Webhook URL",
        "ACTIONS": "Műveletek"
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Törlés",
      "TITLE": "Bot törlése",
      "CONFIRM": {
        "TITLE": "Törlés megerősítése",
        "MESSAGE": "Are you sure you want to delete {name}?",
        "YES": "Igen, Törlés",
        "NO": "Nem, Mégse"
      },
      "API": {
        "SUCCESS_MESSAGE": "Bot törölve.",
        "ERROR_MESSAGE": "Nem sikerült törölni a botot. Kérjük, próbálja újra."
      }
    },
    "EDIT": {
      "BUTTON_TEXT": "Szerkesztés",
      "TITLE": "Bot szerkesztése",
      "API": {
        "SUCCESS_MESSAGE": "Bot frissítve.",
        "ERROR_MESSAGE": "Nem tudta frissíteni a botot. Kérjük, próbálja újra."
      }
    },
    "SECRET": {
      "LABEL": "Webhook Secret",
      "COPY": "Copy secret to clipboard",
      "COPY_SUCCESS": "Secret copied to clipboard",
      "TOGGLE": "Toggle secret visibility",
      "CREATED_DESC": "Use the secret below to verify webhook signatures. Please copy it now, you can also find it later in the bot settings.",
      "DONE": "Done",
      "RESET_SUCCESS": "Webhook secret regenerated successfully",
      "RESET_ERROR": "Unable to regenerate webhook secret. Please try again"
    },
    "ACCESS_TOKEN": {
      "TITLE": "Hozzáférési kulcs",
      "DESCRIPTION": "Copy the access token and save it securely",
      "COPY_SUCCESSFUL": "Access token copied to clipboard",
      "RESET_SUCCESS": "Access token regenerated successfully",
      "RESET_ERROR": "Unable to regenerate access token. Please try again"
    },
    "FORM": {
      "AVATAR": {
        "LABEL": "Bot avatar"
      },
      "NAME": {
        "LABEL": "Bot neve",
        "PLACEHOLDER": "Enter bot name",
        "REQUIRED": "Bot név megadása kötelező"
      },
      "DESCRIPTION": {
        "LABEL": "Leírás",
        "PLACEHOLDER": "Mit csinál ez a bot?"
      },
      "WEBHOOK_URL": {
        "LABEL": "Webhook URL",
        "PLACEHOLDER": "https://example.com/webhook",
        "REQUIRED": "Webhook URL is required"
      },
      "ERRORS": {
        "NAME": "Bot név megadása kötelező",
        "URL": "Webhook URL is required",
        "VALID_URL": "Please enter a valid URL starting with http:// or https://"
      },
      "CANCEL": "Mégse",
      "CREATE": "Create Bot",
      "UPDATE": "Update Bot"
    },
    "WEBHOOK": {
      "DESCRIPTION": "Configure a webhook bot to integrate with your custom services. The bot will receive and process events from conversations and can respond to them."
    },
    "TYPES": {
      "WEBHOOK": "Webhook bot"
    }
  }
}
